import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from './actions';
import { serialize } from './serialize';
import { SimpleFormStateProps, SimpleFormDispatchProps, FormOptions } from './types';
import get from 'lodash/get';
import { AppDispatch } from 'app/infrastructure/configure-store';

const createActions = (path: string) => ({
  validate: actionCreators(path).validate
});

const getValue = (path: string, state: any) => {
  const values = get(state, `${path}.simpleForm.editing.values`) || {};
  return Object.keys(values).reduce((memo, key) => {
    if (values[key]) {
      memo[key] = values[key].value;
    }
    return memo;
  }, {});
};

const getValidation = (path: string, state: any, ownProps: any) => {
  const validation = get(state, `${path}.simpleForm.editing.validation`) || {};
  return {
    ...(!!ownProps && ownProps.validation),
    ...validation
  };
};

const getFormOptions = (path: string, state: any): FormOptions => {
  return get(state, `${path}.simpleForm.tempdata`) || {};
};

const createStateToProps = <TOwnProps>(path: string) => (state: any, props?: TOwnProps): SimpleFormStateProps => ({
  formValues: getValue(path, state),
  serialize: serialize(path, state),
  validation: getValidation(path, state, props),
  formOptions: getFormOptions(path, state)
});

const createMapDispatchToProps = (path: string) => (dispatch: AppDispatch) => ({
  dispatch,
  ...bindActionCreators(createActions(path), dispatch)
});

export const withValidation = (component) => {
  return connect<any, any, any>(undefined, createMapDispatchToProps(component.statePath))(component);
};
export const withSimpleForm = <TOwnProps>(component) => {
  return connect<SimpleFormStateProps, SimpleFormDispatchProps, TOwnProps>(
    createStateToProps<TOwnProps>(component.statePath),
    createMapDispatchToProps(component.statePath)
  )(component);
};
